/**
 * @generated SignedSource<<7699704d0995bbdc63133dc84290d5de>>
 * @relayHash bf929c95e6738104436e6a3b1e6f48cd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcIncidentsLinkedServicesQuery } from './srcIncidentsLinkedServicesQuery.graphql';

const node: PreloadableConcreteRequest<srcIncidentsLinkedServicesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "jiraProjectByKey",
            "associatedComponents"
          ]
        }
      ]
    },
    "name": "srcIncidentsLinkedServicesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
